import {addLocaleData} from 'react-intl';

let useIntlBuiltin = true;
if (typeof Intl === 'undefined') {
  global.Intl = require('intl');
  useIntlBuiltin = false;
}

export default async function loadLocale (buildContext, locale) {
  let intlSupportedLocale = locale.split('-')[0];
  if (buildContext.isPrerender) {
    if (!useIntlBuiltin) {
      __non_webpack_require__(`intl/locale-data/jsonp/${intlSupportedLocale}.js`);
    }
    let localeData = __non_webpack_require__(`react-intl/locale-data/${intlSupportedLocale}`);
    addLocaleData(localeData);
  } else {
    if (!useIntlBuiltin) {
      await import(`intl/locale-data/jsonp/${intlSupportedLocale}.js`);
    }
    addLocaleData(await import(`react-intl/locale-data/${intlSupportedLocale}`));
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-router/loadLocale.js